import { Radio } from "antd";

export type CoefficientMode = "with" | "without";

type Props = {
  value: CoefficientMode;
  onChange: (value: CoefficientMode) => void;
};

const options = [
  { label: "С Кт × Кн", value: "with" as const },
  { label: "Без Кт × Кн", value: "without" as const },
];

const CoefficientToggle = ({ value, onChange }: Props) => (
  <Radio.Group
    value={value}
    onChange={(e) => onChange(e.target.value)}
    options={options}
    optionType="button"
    buttonStyle="solid"
  />
);

export default CoefficientToggle;
